module.exports = __webpack_public_path__ + "img/Icon material-location-on.33e82e2d.svg";